<template>
  <FatButton @click="download">
    {{ $t("table.downloadCSV") }}
  </FatButton>
</template>

<script>
import { exportFile } from 'quasar'

import { createArrayCsvStringifier } from '@/helpers/csv-helpers.js'
import FatButton from './FatButton'

export default {
  components: {
    FatButton
  },
  props: {
    titles: Array,
    tableData: Array
  },
  methods: {
    download () {
      const csvStringifier = createArrayCsvStringifier({
        header: this.titles
      })

      const csvString =
        csvStringifier.getHeaderString() +
        csvStringifier.stringifyRecords(this.tableData)

      exportFile('open-measures-data.csv', csvString, 'text/csv')
    }
  }
}
</script>

<style scoped lang="scss"></style>
